import ChatFileImage from "./ChatFIleImage";

export default ChatFileImage;
